import BasePage from "../../../base/BasePage";
import React from "react";
import { addSchemaUseCase } from "../../../usecases/schema/usecases";
import NominationPresenter from "./NominationPresenter";
import RegionTab from "../../../components/common/RegionTab";
import NominationRequest from "./NominationTable/NominationRequest";
import NominationList from "./NominationTable/NominationList";
import OpenForNominationTable from "./UserNominationTable/OpenForNominationTable";

class NominationPage extends BasePage {
  constructor(props) {
    super(props);
    this.presenter = new NominationPresenter(this, addSchemaUseCase());
    this.state = {
      progress: false,
      isUser: false,
    };
  }

  componentDidMount() {
    const roles = this.getCurrentRoles();
    if (roles.some((item) => item.id === "user")) {
      this.setState({ isUser: true });
    } else {
      this.setState({ isUser: false });
    }
  }

  render() {
    const tabs = [
      { title: "Recognition Request", content: <NominationRequest /> },
      { title: "Recognition List", content: <NominationList /> },
    ];
    const tabContents = tabs.map((tab) => tab.content);

    const userTabs = [
      { title: "Recognition Request", content: <OpenForNominationTable /> },
    ];
    const userTabContents = userTabs.map((tab) => tab.content);
    return (
      <>
        <div
          className="container-fluid d-flex flex-column p-5"
          style={{ marginTop: "4rem" }}
        >
          <div
            className="d-flex mb-4"
            style={{ borderBottom: "1px solid #d3d3d3" }}
          >
            <p style={{ fontSize: "14px", color: "grey" }}>
              You are here: Home &gt; Merit Reward and Recognition &gt;{" "}
              <span style={{ color: "#333" }}>Recognition</span>
            </p>
          </div>
          {this.state.isUser ? (
            <RegionTab tabs={userTabs} tabContents={userTabContents} />
          ) : (
            <RegionTab tabs={tabs} tabContents={tabContents} />
          )}
        </div>
      </>
    );
  }
}

export default NominationPage;
